import { styled, Theme } from '@mui/material';
import { coreThemeColors } from '@youscience/theme';

export const sxStyles = {
  container: {
    marginTop: '4rem',
  },
  sectionTitle: (theme: Theme) => ({
    color: theme.palette.primary.main,
  }),
  sectionSubtitle: (theme: Theme) => ({
    padding: '1.25rem 2rem',
    borderBottom: `1px solid ${theme.palette.grey['300']}`,
  }),
  schoolSubtitle: {
    marginBottom: '2px',
  },
  schoolName: (theme: Theme) => ({
    color: theme.palette.primary.main,
  }),
  schoolLocation: {
    display: 'flex',
    marginTop: '0.75rem',

    '& > div:first-of-type': {
      marginRight: '2.5rem',
    },
  },
  schoolType: {
    display: 'flex',
    marginTop: '2.5rem',
    marginBottom: '0.75rem',

    '& > div:first-of-type': {
      marginRight: '2.5rem',
    },
  },
  schoolWebsite: {
    marginTop: '2.5rem',
  },
  schoolUrl: (theme: Theme) => ({
    display: 'flex',
    marginTop: '1rem',

    '& > svg:first-of-type': {
      marginRight: '0.5rem',
    },

    '& > a:first-of-type': {
      color: theme.palette.common.black,
    },
  }),
  additionalTitle: {
    marginBottom: '1rem',
  },
  classesOffered: {
    marginBottom: '1rem',
  },
  otherHighlights: {
    marginTop: '2.5rem',
  },
  schoolHighlights: {
    display: 'flex',
    marginTop: '1rem',

    '& > div:first-of-type': {
      marginRight: '0.75rem',
    },
  },
  awardsDegreesWrap: {
    marginTop: '2.5rem',
  },
  awardsDegrees: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '1rem 2rem',
    marginTop: '1.5rem',
  },
};

export const StyledGeneralInformationWrap = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.common.white,
  width: '100%',
  boxShadow: '0px 5px 25px rgba(17, 77, 76, 0.1)',
  borderRadius: '0.5rem',
  marginTop: '2.25rem',
}));

export const StyledGeneralInformationInner = styled('div')(({ theme }) => ({
  padding: '2.5rem 2rem',

  [theme.breakpoints.up('md')]: {
    padding: '2.5rem 3.5rem 4rem',
  },
}));

export const StyledSchoolDetails = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',

  '& > div:first-of-type': {
    maxWidth: '50%',
    marginRight: '1.5rem',
  },

  '& > div:last-of-type': {
    maxWidth: '50%',
    width: '100%',
  },

  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',

    '& > div:first-of-type': {
      maxWidth: '100%',
      marginRight: 0,
    },

    '& > div:last-of-type': {
      marginTop: '2.5rem',
      maxWidth: '100%',
    },
  },
}));

export const StyledDegree = styled('div', {
  shouldForwardProp: (prop) => prop !== 'isAwardDegree',
})<{ isAwardDegree?: boolean }>(({ isAwardDegree, theme }) => ({
  display: 'flex',
  padding: '0.375rem 1.5rem',
  minWidth: '144px',
  backgroundColor: isAwardDegree ? coreThemeColors.primary.outlinedHoverBackground : '',
  border: isAwardDegree ? `1px solid ${theme.palette.primary.main}` : `1px solid ${theme.palette.common.white}`,
  borderRadius: isAwardDegree ? '1rem' : '',

  '& > div:first-of-type': {
    marginRight: '0.625rem',
  },

  [theme.breakpoints.up('md')]: {
    padding: isAwardDegree ? '0.375rem 1.5rem' : '0.375rem 0',
    minWidth: isAwardDegree ? '144px' : 'auto',
  },
}));
